export default "__VITE_ASSET__CFmR54uV__"